import { jsxs as _jsxs, jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { Button, Component_GenericRenderer, LL_H_C, LL_V_L, stopPropagation, TS_CollapsableContainer, TS_PropRenderer } from '@nu-art/thunderstorm-frontend/index';
import { ICONS } from '@app/styles';
import { Renderer_CriticalityTable } from '../../Renderer_CriticalityTable/Renderer_CriticalityTable.js';
import { sortArray } from '@nu-art/ts-common';
import { ConfigKeyFE_DiseasesViewsTagId, ModuleFE_Tag, QScrollWrapper } from '@app/hcs-frontend';
import { Header_Pathway } from '../../../../headers/Header_Pathway.js';
import { Section_PathwayStates } from './panel-sections/Section_PathwayStates.js';
import { Section_AllPathwayTransitions } from './panel-sections/Section_AllPathwayTransitions.js';
import { Section_AllPathwayOrders } from './panel-sections/Section_AllPathwayOrders.js';
import { Section_AllEntityVariables } from '../../common-components/Section_AllEntityVariables.js';
import { canEditPathway } from '../../../../utils.js';
import { Section_PathwayTags } from './panel-sections/Section_PathwayTags.js';
import { Section_PathwayChildren } from './panel-sections/Section_PathwayChildren.js';
import { detachPathwayFromParent } from '../../../../ui-utils.js';
import { TS_EditableItemComponentProto } from '@nu-art/thunderstorm-frontend/editable-item';
import { ModuleFE_DiseaseProfile, ModuleFE_MultiVar } from '@app/dp-frontend';
import { ModuleFE_Pathway } from '../../../../../../_entity/pathway/index.js';
import { Editor_ScoreRef } from '@app/dp-frontend/ui/_managers/Manager_DiseaseProfile/renderers/Editor_DiseaseProfile/tabs/Editor_DiseaseProfile_Scores/Editor_DiseaseProfile_Scores';
export class Renderer_PathwayDetails extends TS_EditableItemComponentProto {
    // ######################## Logic ########################
    getDDs = () => {
        const pathway = this.props.editable.item;
        if (pathway.type !== 'chief-complaint' || !pathway.variableIds?.length)
            return [];
        const complaintsTagId = this.getComplaintsTagId();
        if (!complaintsTagId)
            return [];
        const dds = ModuleFE_DiseaseProfile.cache.filter(dp => {
            return !!ModuleFE_MultiVar.cache.find(mv => {
                return mv.diseaseProfileId === dp._id
                    && !!pathway.variableIds?.includes(mv._firstVarId)
                    && !!mv.variables[0].tagIds.find(tagGroup => tagGroup.value.includes(complaintsTagId));
            });
        });
        return sortArray(dds, dd => dd.label.toLowerCase());
    };
    getComplaintsTagId = () => {
        const dvTagId = ConfigKeyFE_DiseasesViewsTagId.get();
        const complaintsTag = ModuleFE_Tag.cache.find(tag => tag.tagIds.includes(dvTagId) && tag.label.toLowerCase() === 'complaints');
        if (!complaintsTag)
            this.logError('Could not find complaints tag');
        return complaintsTag?._id;
    };
    setCriticalityTableView = (view, e) => {
        stopPropagation(e);
        this.setState({ criticalityTableView: view });
    };
    // ######################## Render ########################
    render() {
        return _jsxs(LL_V_L, { className: 'match_parent', style: { padding: '30px', gap: '10px' }, children: [this.renderHeader(), this.renderBody()] });
    }
    // ######################## Render - Header ########################
    renderHeader = () => {
        return _jsxs(_Fragment, { children: [this.renderTopButtons(), _jsx(Header_Pathway, { pathway: this.props.editable, functions: this.props.functions, allowActions: canEditPathway(this.state.editable.item) })] });
    };
    renderTopButtons = () => {
        return _jsxs(LL_H_C, { className: 'pathway__top-buttons', children: [!this.state.criticalityTableView &&
                    _jsx(Button, { variant: 'text', className: 'pathway__top-buttons__back', onClick: this.props.functions.deselectPathway, children: '< Back to list' }), this.state.criticalityTableView &&
                    _jsx(Button, { variant: 'text', className: 'pathway__top-buttons__back', onClick: e => this.setCriticalityTableView(false, e), children: '< Back to Pathway Overview' })] });
    };
    // ######################## Render - Body ########################
    renderBody = () => {
        if (this.state.criticalityTableView)
            return _jsx(Renderer_CriticalityTable, { pathway: this.props.editable.item });
        return _jsxs(QScrollWrapper, { className: 'match_width', children: [this.renderDescription(), this.renderArchivedPathway(), this.renderOrgName(), this.renderTagGroups(), this.renderScoreRefs(), this.renderStates(), this.renderTransitions(), this.renderDDs(), this.renderOrders(), this.renderChildPathways(), this.renderHCSVariables()] });
    };
    renderArchivedPathway = () => {
        const pathway = this.state.editable.item;
        if (!pathway.archived)
            return;
        return (_jsxs(LL_H_C, { className: 'pathway__archived', children: [_jsx(ICONS.archive.component, { className: 'pathway__archived__icon' }), _jsx("p", { className: 'pathway__archived__label', children: "Archived" })] }));
    };
    renderOrgName = () => {
        return _jsx(Component_GenericRenderer, { rendererKey: 'organization-permission-editor', props: {
                item: this.state.editable.item,
                module: ModuleFE_Pathway,
                preSelectCallback: async () => detachPathwayFromParent(this.state.editable.get('_id')),
                disabled: canEditPathway(this.state.editable.item),
                direction: 'Horizontal'
            } });
    };
    renderDescription = () => {
        const pathway = this.props.editable.item;
        if (!pathway.description)
            return;
        return _jsx("p", { className: 'pathway__description', children: pathway.description });
    };
    renderStates = () => {
        return _jsx(Section_PathwayStates, { pathwayId: this.state.editable.get('_id'), functions: this.props.functions });
    };
    renderTransitions = () => {
        return _jsx(Section_AllPathwayTransitions, { functions: this.props.functions, pathwayId: this.state.editable.get('_id') });
    };
    renderDDs = () => {
        const dds = this.getDDs();
        if (!dds.length)
            return;
        return _jsx(TS_CollapsableContainer, { headerRenderer: _jsxs(_Fragment, { children: [dds.length, " DDs", _jsx("div", { className: 'criticality-table-button', onClick: e => this.setCriticalityTableView(true, e), children: "See Criticality Table" })] }), containerRenderer: _jsx(_Fragment, { children: dds.map(dd => _jsx("div", { children: dd.label }, dd._id)) }), customCaret: _jsx(ICONS.advisorArrowDown.component, {}) });
    };
    renderHCSVariables = () => {
        return _jsx(Section_AllEntityVariables, { functions: this.props.functions, pathwayId: this.state.editable.get('_id') });
    };
    renderOrders = () => {
        return _jsx(Section_AllPathwayOrders, { functions: this.props.functions, pathwayId: this.state.editable.get('_id') });
    };
    renderChildPathways = () => {
        return _jsx(Section_PathwayChildren, { pathwayId: this.state.editable.get('_id'), functions: this.props.functions });
    };
    renderTagGroups = () => {
        return _jsx(Section_PathwayTags, { pathway: this.state.editable.item });
    };
    renderScoreRefs = () => {
        const editable = this.state.editable.editProp('scoreReferences', []);
        return _jsx(TS_PropRenderer.Vertical, { label: 'Scores', children: _jsx(LL_H_C, { className: 'e__pathway__score-refs', children: editable.item.map((ref, index) => {
                    const editableScore = editable.editProp(index, {});
                    editableScore.setOnDelete(async () => editable.removeArrayItem(index));
                    return _jsx(Editor_ScoreRef, { editable: editableScore, editMode: false }, index);
                }) }) });
    };
}
//# sourceMappingURL=Renderer_PathwayDetails.js.map